
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 13.5a6 6 0 00-6-6 6 6 0 00-6 6V19a1.5 1.5 0 01-1.5 1.5h15A1.5 1.5 0 0118 19v-5.5zm-4.585 9a1.5 1.5 0 01-1.415 1 1.5 1.5 0 01-1.414-1M12 5.501v2M8.5 4A4.5 4.5 0 004 8.5m-3.5 0a8 8 0 018-8m7 3.5a4.5 4.5 0 014.157 2.778A4.5 4.5 0 0120 8.5m3.5 0a8 8 0 00-8-8","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    